import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CaretDown } from '@phosphor-icons/react';
import { DOCS_CATEGORIES } from '@/pages/docs/docsData';

export default function DocsSidebar({ onNavigate }) {
  const { category: activeCategory, slug: activeSlug } = useParams();
  const [expanded, setExpanded] = useState(() => {
    const initial = {};
    DOCS_CATEGORIES.forEach(cat => {
      initial[cat.id] = cat.id === activeCategory || cat.id === 'getting-started';
    });
    return initial;
  });

  const toggle = (id) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <nav aria-label="Documentation navigation" className="space-y-1" data-testid="docs-sidebar">
      {DOCS_CATEGORIES.map(cat => {
        const Icon = cat.icon;
        const isExpanded = expanded[cat.id];
        const isCategoryActive = cat.id === activeCategory;

        return (
          <div key={cat.id}>
            <button
              onClick={() => toggle(cat.id)}
              className={`w-full flex items-center gap-2 px-3 py-2 text-left rounded-sm transition-colors ${isCategoryActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'}`}
              data-testid={`docs-cat-${cat.id}`}
            >
              <Icon size={14} weight="bold" style={{ color: cat.color }} className="flex-shrink-0" />
              <span className="text-[12px] font-semibold flex-1 truncate">{cat.title}</span>
              <CaretDown
                size={12}
                weight="bold"
                className={`flex-shrink-0 text-muted-foreground transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
              />
            </button>
            {isExpanded && (
              <div className="ml-5 pl-3 border-l border-border space-y-0.5 mt-0.5 mb-2">
                {cat.articles.map(article => {
                  const isActive = isCategoryActive && article.slug === activeSlug;
                  return (
                    <Link
                      key={article.slug}
                      to={`/docs/${cat.id}/${article.slug}`}
                      onClick={onNavigate}
                      className={`block px-2 py-1.5 text-[12px] rounded-sm transition-colors ${isActive ? 'font-semibold text-foreground bg-secondary' : 'text-muted-foreground hover:text-foreground hover:bg-secondary/50'}`}
                      style={isActive ? { borderLeft: `2px solid ${cat.color}`, marginLeft: '-13px', paddingLeft: '19px' } : {}}
                      data-testid={`docs-link-${cat.id}-${article.slug}`}
                    >
                      {article.title}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
}
